import { Reveal } from "@/components/Reveal";
import { Phone, Mail, Instagram, Linkedin } from "lucide-react";
import { BRAND } from "@/data";

export const AgentBio = () => {
  return (
    <section id="about" data-testid="about-section" className="relative bg-kw-ink text-white grain overflow-hidden">
      <div className="relative max-w-7xl mx-auto px-5 sm:px-8 py-20 sm:py-28 grid lg:grid-cols-12 gap-12 items-center">
        <Reveal className="lg:col-span-7 order-2 lg:order-1">
          <p className="overline text-kw-red mb-5">Meet Your Agent</p>
          <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.02]">
            {BRAND.name}
          </h2>
          <p className="mt-2 overline text-neutral-400">{BRAND.brokerage}</p>

          <p className="mt-7 text-neutral-300 leading-relaxed max-w-xl">
            As your trusted Denver real estate specialist, I help clients buy and sell homes with
            confidence, strategy, and personalized service. With a strong background in luxury real
            estate, renovations, and investment properties, I bring hands-on expertise and a modern
            marketing approach to every transaction.
          </p>
          <p className="mt-4 text-neutral-300 leading-relaxed max-w-xl">
            Whether you're a first-time buyer, an investor, or listing your home for top value, I'm
            committed to making the process seamless, transparent, and rewarding — backed by Keller
            Williams' trusted network and my local expertise.
          </p>

          <div className="mt-9 flex flex-wrap items-center gap-5">
            <a
              href={BRAND.phoneHref}
              data-testid="bio-phone"
              className="inline-flex items-center gap-2 bg-kw-red hover:bg-kw-redhover px-6 py-3 text-sm font-semibold transition-colors duration-300"
            >
              <Phone size={15} /> {BRAND.phone}
            </a>
            <a
              href={`mailto:${BRAND.email}`}
              data-testid="bio-email"
              className="inline-flex items-center gap-2 text-sm text-neutral-300 hover:text-white transition-colors"
            >
              <Mail size={15} /> {BRAND.email}
            </a>
            <div className="flex items-center gap-4 text-neutral-400">
              <a href={BRAND.social.instagram} target="_blank" rel="noreferrer" aria-label="Instagram" className="hover:text-kw-red transition-colors"><Instagram size={18} /></a>
              <a href={BRAND.social.linkedin} target="_blank" rel="noreferrer" aria-label="LinkedIn" className="hover:text-kw-red transition-colors"><Linkedin size={18} /></a>
            </div>
          </div>
        </Reveal>

        <Reveal delay={0.15} className="lg:col-span-5 order-1 lg:order-2">
          <div className="relative">
            <div className="absolute -top-4 -left-4 w-full h-full border border-kw-red" />
            <img src={BRAND.headshot} alt={BRAND.name} className="relative w-full h-[420px] sm:h-[520px] object-cover object-top" />
          </div>
        </Reveal>
      </div>
    </section>
  );
};
